// hooks/useAiMarketplaceRedirect.ts
import { FeatureFlagsConstants } from "@/constant";
import { useCheckFeatureApprovedQuery } from "@/redux/feature/featureFlag/featureFlagApi";
import { useAppSelector } from "@/redux/hooks/hooks";

export const useAiMarketplaceRedirect = ({
  setModalOpen,
}: {
  setModalOpen?: (open: boolean) => void;
}) => {
  const { user, token } = useAppSelector((state) => state.auth);

  const { data: feature } = useCheckFeatureApprovedQuery(
    {
      email: user?.email as string,
      featureKey: FeatureFlagsConstants.AI_MARKET_PLACE,
    },
    {
      skip: !user?.email,
    }
  );

  const isApproved = feature?.data?.approved;

  const baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_AI_MARKET_PLACE_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_AI_MARKET_PLACE_STAGE
      : import.meta.env.VITE_API_AI_MARKET_PLACE_PROD;

  const redirect = ({ teamId }: { teamId?: string }) => {
     if (token && user?.email) {
      const params = new URLSearchParams({
        t: token,
      });

      if (teamId) {
        params.append("teamId", teamId);
        // ✅ If `teamId` is present, bypass approval
        window.location.href = `${baseUrl}/auth/verify?${params.toString()}`;
        return;
      }

      if (isApproved) {
        // ✅ If no `teamId`, check approval
        window.location.href = `${baseUrl}/auth/verify?${params.toString()}`;
      } else {
        setModalOpen?.(true);
      }
    } else {
      setModalOpen?.(true);
    }

  };

  return { redirect, isApproved };
};
